<template>
  <div class="sidebar">
    <div class="sidebar-wrap">
      <div class="hotnews lawlist boxshadow1" style="margin:0">
        <Input class="search" v-model="LawerVal" icon="ios-search" type="text" placeholder="输入文章内容" style="width:100%" @on-enter="lawSearch" @on-click="lawSearch"/>
        <div class="title">相关政策</div>
        <ul>
          <li v-for="(item, index) in policylist" :key="index" @click="$router.push({name: 'LawsShow', params: {id: item.id}})">
            <div class="t1">{{item.title}}</div>
          </li>
        </ul>
      </div>
      <div class="hotnews boxshadow1">
        <Input class="search" v-model="searchVal" icon="ios-search" type="text" placeholder="输入文章内容" style="width:100%" @on-enter="search" @on-click="search"/>
        <div class="title">热门新闻</div>
        <ul>
          <li v-for="(item, index) in hotNewsList" :key="'related-news-' + index" @click="$router.push({name: 'NewsShow', params: {id: item.id}})">
            <img :src="item.coverImage" v-if="item.coverImage">
            <div class="t1">{{item.title}}</div>
            <div class="t2">{{item.content | removeTag(' ')}}</div>
          </li>
        </ul>
      </div>
      <div class="hotnews suggest boxshadow1">
        <div class="title">专家建议</div>
        <div class="desc">为企业提供一对一咨询，根据企业自身需求特点，提供量身定制的贸易咨询服务及贸易合规管理解决方案，包括关税筹划、预裁定申请、流程梳理、政策解读等。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'RcepListSider',
  data () {
    return {
      searchVal: '',
      LawerVal: ''
    }
  },
  computed: {
    hotNewsList () {
      return (this.list || []).slice(0, 5)
    },
    policylist () {
      return (this.list2 || []).slice(0, 5)
    },
    ...mapDataState({
      'list': state => state.relatedNews,
      'list2': state => state.relevantPolicy
    })
  },
  methods: {
    lawSearch () {
      if (this._.trim(this.LawerVal)) {
        this.$router.push({name: 'Laws', query:{ k: this.LawerVal }})
      }
    },
    search () {
      if (this._.trim(this.searchVal)) {
        this.$router.push({name: 'News', query:{ k: this.searchVal }})
      }
    }
  }
}
</script>
<style scoped>
  .sidebar-wrap{
    padding-bottom: 20px;
  }
  .title{
    font-size: 1.6rem;
    color: #333;
    /* background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent; */
    background-size: 12px;
    /* padding-left: 18px; */
    margin-bottom: 15px;
    position: relative;
    top: 1px;
  }
  .searchbox{
    padding: 12px 16px 18px;
  }
  .searchbox .search{
    margin-bottom: 15px;
  }
  .searchbox >>> .ivu-input,
  .daterange >>> .ivu-input{
    border-color: #999;
    border-radius: 3px;
    padding-left: 12px;
    font-size: 15px;
    border-width: 0.5px;
    color: #333;
  }
  .searchbox >>> .ivu-input:focus,
  .daterange >>> .ivu-input:focus{
    border-color: #0470e3;
  }
  .searchbox >>> .ivu-input::-webkit-input-placeholder,
  .daterange >>> .ivu-input::-webkit-input-placeholder{
    font-size: 14px;
  }
  .searchbox >>> .ivu-input:-moz-placeholder,
  .daterange >>> .ivu-input:-moz-placeholder{
    /*font-size: 10px;*/
    font-size: 12px;
  }
  .searchbox >>> .ivu-input::-moz-placeholder,
  .daterange >>> .ivu-input::-moz-placeholder{
    /*font-size: 10px;*/
    font-size: 12px;
  }
  .searchbox >>> .ivu-input:-ms-input-placeholder,
  .daterange >>> .ivu-input:-ms-input-placeholder{
    /*font-size: 10px;*/
    font-size: 12px;
  }
  .search >>> .ivu-icon,
  .daterange >>> .ivu-icon-ios-close{
    cursor: pointer;
  }
  .daterange >>> .ivu-icon-ios-calendar-outline{
    background: url("~@/assets/images/icons/news/cal.png") center center no-repeat transparent;
    background-size: 12px;
  }
  .search >>> .ivu-icon-ios-search-strong:before,
  .daterange >>> .ivu-icon-ios-calendar-outline:before{
    content: none;
  }
  .daterange >>> .ivu-select-dropdown{
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .daterange >>> .ivu-select-dropdown .ivu-date-picker-cells-header span{
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .hotnews{
    margin-top: 20px;
    padding: 12px 16px 18px;
  }
  .suggest .title{
    background: url("~@/assets/images/home/light.png") 0 center no-repeat transparent;
    background-size: 16px;
    padding-left: 20px;
  }
  .suggest .desc{
    font-size: 15px;
    line-height: 24px;
  }
  .hotnews ul{
    margin-left: 0;
  }
  .hotnews ul li{
    padding: 0 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .hotnews ul li:hover .t1{
    color: #0470e3;
  }
  .hotnews img{
    border-radius: 3px;
    margin-bottom: 8px;
  }
  .hotnews .t1{
    font-size: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 8px;
  }
  .hotnews .t2{
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    color: #999;
    font-size: 14px;
  }
  .classify{
    margin: 30px 0;
    padding-bottom: 20px;
    border-bottom: 0.5px solid #E9E9E9;
    padding: 12px 16px 18px;
  }
  .classify .title{
    margin-bottom: 7px;
  }
  .tags span{
    font-size: 14px;
    display: inline-block;
    margin: 6px 5px;
    cursor: pointer;
  }
  .tags span.active{
    color: #0470e3;
  }
  ul{
    margin-top: 15px;
    margin-left: 10px;
  }
  ul li{
    margin-bottom: 10px;
    padding-left: 12px;
  }
  ul li:last-child{
    margin-bottom: 0;
  }
  ul li a{
    color: #999;
    /*font-size: 1.1rem;*/
    font-size: 1.3rem;
  }
  /*.classify ul li a:after{*/
  /*background-color: #999;*/
  /*}*/
  ul li a:hover{
    color: #1F8AFD;
  }
  ul li.active a:after{
    width: 0;
    height: 0;
  }
  ul li.active a{
    color: #1F8AFD;
  }
  ul li.active{
    background: url("~@/assets/images/icons/news/arrow.png") 0 center no-repeat transparent;
    background-size: 7px auto;
  }
  .hotnews .search{
    margin: 10px 0 15px;
  }
  .lawlist ul li{
    margin-bottom: 10px;
    border-bottom: 0.5px solid #f1f1f1;
    padding-left: 0;
    padding-right: 15px;
  }
  .lawlist ul li div{
    background: url("~@/assets/images/home/arr.png") 0 center no-repeat transparent;
    background-size: 10px;
    padding-left: 15px;
  }
  .lawlist ul li div:hover{
    color: #0470e3;
  }
  .lawlist .t1{
    padding-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/news2/ContentSider.vue